import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Footer = function Footer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  return /*#__PURE__*/React.createElement("footer", _extends({}, rest, {
    className: classnames('ln-c-footer', className),
    role: "contentinfo"
  }), children);
};

Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
Footer.defaultProps = {
  children: undefined,
  className: undefined
};
Footer.displayName = 'Footer';

var FooterNav = function FooterNav(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "label"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames('ln-c-footer__nav', className),
    "aria-label": label
  }), children);
};

FooterNav.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,

  /** Screen reader description for page landmark */
  label: PropTypes.string
};
FooterNav.defaultProps = {
  element: 'nav',
  children: undefined,
  className: undefined,
  label: 'Footer navigation'
};
FooterNav.displayName = 'FooterNav';

export { Footer, FooterNav };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/footer/dist/index.js
// module id = 233
// module chunks = 0